export default __webpack_public_path__ + "static/media/bullet-level99logo.ff739146.png";